module.exports = "<div class=\"width(max)\" ng-transclude=\"tab\"></div>\n";